import { render, staticRenderFns } from "./AccordionContentBlock.vue?vue&type=template&id=0d3d57ee"
import script from "./AccordionContentBlock.vue?vue&type=script&lang=ts"
export * from "./AccordionContentBlock.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports